import { inject } from "aurelia-dependency-injection";
import { AxiosInstance, AxiosResponse } from "axios";
import { createValidationError } from "utils/response";
import { TDescargaDatosTipoDatos } from "./descarga-datos.interface";

@inject('axios')
export class DescargaDatosGateway { 
    constructor(
        private axios: AxiosInstance
    ) { }

    public async downloadDatosAyuda(tipoDatosAyuda: TDescargaDatosTipoDatos): Promise<{ fileName: string, blob: Blob }> {
        const response = await this.axios.get(`descarga-datos/descargar-datos-ayuda/${tipoDatosAyuda}`, {
            responseType: 'blob',
        });
    
        const disposition = response.headers['content-disposition'];
        // eslint-disable-next-line no-useless-escape
        const match = /^filename=\"?(.+?)\"?$/gmi.exec(disposition);
        const fileName = match ? match[1] : 'exportacion.xlsx';
        return {
            fileName,
            blob: response.data
        };
    }
}
